import React, { Component } from 'react';
import HtmlToReact from 'html-to-react';

class Error extends Component {
    constructor(props) {
        super(props);
        this.state = {
            success: props.ticket.success,
            message: props.ticket.message,
            code: props.ticket.code,
        };
    }

    componentDidMount() {
        this.props.actions.drawTicketActions.reset();
        this.props.actions.fastPlayTicketActions.reset();
        this.props.actions.scratchTicketActions.reset();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.ticket.message !== this.props.ticket.message) {
            this.setState({
                success: this.props.ticket.success,
                message: this.props.ticket.message,
                code: this.props.ticket.code,
            });
        }
    }

    //* Covering Ticket Service Issues
    // When you receive the real error codes in the message property.
    // Please view full list of BE error codes here: http://sciplay-git.ad.scigames.com/eos/eos-common/-/blob/ENSEMBLE_v5.0/src/Exceptions/TicketServiceException.php
    translateMessageErrorCodes(code, message) {
        const errorCodeMatrix = {
            _DUPLICATE: 'The ticket has already been entered.',
            _DUPLICATE_TICKET: 'The ticket has already been entered.',
            _BAD_BONUS_RESPONSE: 'This ticket has already been submitted for a promotion.',
            _BAD_HOST_RESPONSE: 'Invalid response received from ticket host.',
            _TOKEN_EXPIRED: 'Your session has timed out. Please log-in again.',
            _INVALID_TICKET: 'Invalid ticket.',
            _BAD_BONUSING_RESPONSE: 'Bad response from bonusing.',
            _HOST_CONNECTION_ERROR: 'Host connection error.',
            _DEVICE_LOCKEDOUT: 'Device locked out',
            _SYSTEM_ERROR: 'System error.',
            _INVALID_DATE: 'Invalid date.',
            _JURISDICTION_NOT_SUPPORTED: 'Jurisdiction not supported.',
            _INVALID_REQUEST: 'Invalid request.',
            _PLAYER_LOCKEDOUT: 'Player locked out.',
            _PLAYER_CONSECUTIVE_LOCKEDOUT: 'You have exceeded the maximum number of unsuccessful entry attempts. You may try again in one (1) hour.',
            _PLAYER_NOT_FOUND: 'Player not found.',
            _REQUIRED_PARAMETER_MISSING: 'Parameter missing.',
            _DUPLICATE_BY_ANOTHER_PLAYER: 'Duplicate of another player ticket.',
            _UNAUTHORIZED: 'Unauthorized.',
            _CLIENT_FAILED: 'Unknown client error from ticket service.',
            _SERVER_FAILED: 'Unknown server error from ticket service.',
            _BAD_GAMES: 'Failed to get Lotto Games List.',
        };

        return errorCodeMatrix[code || message] || errorCodeMatrix[message] || message;
    }

    render() {
        if (this.state.message) {
            const isSuccess = this.state.success
                ? 'alert-success'
                : 'alert-danger';

            const Parser = HtmlToReact.Parser();

            return (
                <div
                    className={
                        'col-md-8 offset-md-2 ' +
                        isSuccess +
                        ' alert text-center entry-alert'
                    }
                    role="alert"
                >
                    {Parser.parse(this.translateMessageErrorCodes(this.state.code, this.state.message))}
                </div>
            );
        } else {
            return <></>;
        }
    }
}

export default Error;
